import { useTypedParams } from '@sorare/routing';

import { SquadJoin } from '#src/components/squad/SquadJoin/index.tsx';
import { SquadJoinFromLink } from '#src/components/squad/SquadJoinFromLink/index.tsx';
import { useEnablePublicSquads } from '#src/hooks/squad/useEnablePublicSquads.ts';

import type { PageParams } from './__generated__/routeParams.ts';

const SquadJoinCodePage = () => {
  const { code } = useTypedParams<PageParams>();
  const enablePublicSquads = useEnablePublicSquads();

  if (enablePublicSquads) {
    return <SquadJoinFromLink code={code} />;
  }

  return <SquadJoin code={code} />;
};
export default SquadJoinCodePage;
